import { render, staticRenderFns } from "./TravelDataSection.vue?vue&type=template&id=5a0d5132&scoped=true&"
import script from "./TravelDataSection.vue?vue&type=script&lang=js&"
export * from "./TravelDataSection.vue?vue&type=script&lang=js&"
import style0 from "./TravelDataSection.vue?vue&type=style&index=0&id=5a0d5132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d5132",
  null
  
)

export default component.exports